import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedCurrency',
  pure: false  // required to upcurrency the value when currentLang is changed
})
export class LocalizedCurrencyPipe implements PipeTransform {
  private value: string|null;
  private lastCurrency: any;
  private lastLang: string;

  constructor(private translate: TranslateService) { }

  transform(currency: any): any {
    const currentLang = this.translate.currentLang;

    // if we ask another time for the same currency & locale, return the last value
    if (currency === this.lastCurrency && currentLang === this.lastLang) {
      return this.value;
    }

    this.value = new CurrencyPipe(currentLang).transform(currency, 'BGN');
    this.lastCurrency = currency;
    this.lastLang = currentLang;

    return this.value;
  }
}
